module.exports = __webpack_public_path__ + "r-v3/img/arrow_triangle_down.5080c473.svg";